"use client";

export { default } from "./StudioScreenRenderer.core";
export type { StudioScreenRendererProps } from "./StudioScreenRenderer.core";
